import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 2fr;
	align-items: center;
	justify-content: space-between;
	gap: 5px;
`;

export const title = styled.p`
	text-transform: capitalize;
	font-size: 1.25rem;
	color: ${color.interface.white};
	font-family: nunito-bold;
`;

export const group = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	> div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 5px;
	}
`;

export const timer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 5px;

	p,
	b {
		color: ${color.interface.white};
		font-family: nunito-bold;
	}
`;

export const number = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px 6px;
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.2);

	> p {
		font-size: 1.25rem;
	}
`;

export const hourText = styled.p`
	font-size: 1rem;
	font-family: nunito-regular !important;
`;
